<template>
  <div>
    <a
      class="text-decoration-none text-subtitle-2 font-weight-bold"
      @click="returnBack"
    >
      <v-icon
        color="primary"
        dense
        class="mr-2"
      >
        {{ icons.mdiArrowLeft }}
      </v-icon>
      Kembali
    </a>
    <div class="title mb-8 mt-5">
      <h2 class="font-weight-bold black--text text-capitalize">
        {{ exam.title }}
      </h2>
    </div>
    <v-card>
      <v-tabs
        v-model="tab"
        show-arrows
        fixed-tabs
      >
        <v-tab
          v-for="tabItem in tabs"
          :key="tabItem.title"
        >
          <span>{{ tabItem.title }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="pa-6"
      >
        <v-tab-item>
          <elearning-result-table></elearning-result-table>
        </v-tab-item>
        <v-tab-item>
          <elearning-question-exam></elearning-question-exam>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mdiArrowLeft } from '@mdi/js'
import ElearningQuestionExam from './result/ElearningQuestionExam.vue'
import ElearningResultTable from './result/ElearningResultExam.vue'

export default {
  name: 'ElearningSubjectResult',
  components: {
    ElearningResultTable,
    ElearningQuestionExam,
  },
  data() {
    return {
      tab: '',
      tabs: [{ title: 'Hasil Ujian' }, { title: 'Soal Ujian' }],
      icons: {
        mdiArrowLeft,
      },
      exam: {},
      question: {
        answer_key: {},
      },
      answer: {},
    }
  },
  mounted() {
    this.getExam(this.$route.params.uuid)
  },
  methods: {
    returnBack() {
      return this.$router.back()
    },
    async getExam(uuid) {
      await this.$services.ApiServices.get('exam', uuid).then(({ data }) => {
        this.exam = data.data
      })
    },
  },
}
</script>

<style>
</style>
